package pt.at.oss.kotlin.manual.storage.common.contactname.generationidentifiers

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * GenerationIdentifiersEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class GenerationIdentifiersEntry(
    var name: String = ""
) : BaseRecord()
